import { TagAlertEventType } from '../../../core/services/hubs/models/tag-alert-event-type.model';

export interface TagAlertEventDescriptor {
    eventType?: TagAlertEventType | null;
}

export function isAccessRuleTagAlert(alert: TagAlertEventDescriptor): boolean {
    return alert.eventType === TagAlertEventType.AccessRuleViolation;
}
